import React from 'react';

const SuperAdminConfig = React.lazy(
  () =>
    import(
      'src/latest/src/features/super-admin/super-admin-config/SuperAdminConfig'
    ),
);

const SuperAdminHome = React.lazy(
  () =>
    import(
      'src/latest/src/features/super-admin/super-admin-home/SuperAdminHome'
    ),
);

const SuperAdminDocuments = React.lazy(
  () =>
    import(
      'src/latest/src/features/super-admin/super-admin-documents/SuperAdminDocuments'
    ),
);

const SuperAdminUsers = React.lazy(
  () =>
    import(
      'src/latest/src/features/super-admin/super-admin-users/SuperAdminUsers'
    ),
);

const SuperAdminScheduler = React.lazy(
  () =>
    import(
      'src/latest/src/features/super-admin/super-admin-scheduler/SuperAdminScheduler'
    ),
);

const PracticeAdminKpiDashboard = React.lazy(
  () =>
    import(
      'src/latest/src/features/practice-admin/practice-admin-kpi-dashboard/PracticeAdminKpiDashboard'
    ),
);

export const superAdminRoutes = [
  {
    path: 'dashboard',
    name: 'PracticeAdminKpiDashboard',
    component: PracticeAdminKpiDashboard,
    extact: true,
  },
  {
    path: 'home',
    name: 'SuperAdminHome',
    component: SuperAdminHome,
    extact: true,
  },
  {
    path: 'config',
    name: 'SuperAdminConfig',
    component: SuperAdminConfig,
    extact: true,
  },
  {
    path: 'users',
    name: 'Users',
    component: SuperAdminUsers,
    extact: true,
  },
  {
    path: 'documents',
    name: 'documents',
    component: SuperAdminDocuments,
    extact: true,
  },
  {
    path: 'schedulers',
    name: 'SuperAdminScheduler',
    component: SuperAdminScheduler,
    extact: true,
  },
];
